import CancellableHelper from "@/requests/CancellableHelper";
import {
  ContractorExportIntegrationSettingResponse,
  ContractorExportSetting,
  ExportBetweenOfficeSetting,
} from "@/models/api/administration/contractors/ContractorExportIntegrationSettingResponse";

import { SelectItem } from "@/models/api/SelectItem";

//#region routes
export const URL_GET_CONTRACTOR_EXPORT_INTEGRATION_SETTING =
  "/ContractorAdministration/${ContractorId}/ExportIntegrationSetting";
export const URL_GET_PAIR_COST_DOCUMENT_SETTING = "/ContractorAdministration/${ContractorId}/PairCostDocumentSettings";
export const URL_POST_EDIT_EXPORT_BETWEEN_OFFICE_SETTING =
  "/ContractorAdministration/${ContractorId}/EditExportBetweenOfficeSetting";
export const URL_POST_ADD_PAIR_COST_DOCUMENT = "/ContractorAdministration/${ContractorId}/PairCostDocument/Add";
export const URL_POST_REMOVE_PAIR_COST_DOCUMENT =
  "/ContractorAdministration/${ContractorId}/PairCostDocument/${PairCostDocumentId}/Remove";
export const URL_POST_SET_CONTRACTOR_EXPORT_SETTING = "/ContractorAdministration/${ContractorId}/ExportSetting";
export const URL_POST_EDIT_API_INTEGRATION_SETTING =
  "/ContractorAdministration/${ContractorId}/EditApiIntegrationSetting";
export const URL_POST_SAVE_KSEF_INTEGRATION_SETTING = "/ContractorAdministration/${ContractorId}/KSEFIntegration";
export const URL_POST_SAVE_PAIR_COST_DOCUMENT_SETTING =
  "/ContractorAdministration/${ContractorId}/SavePairCostDocumentSettings";
export const URL_GET_COST_DOCUMENT_CREATOR_OFFICE = "/CostDocument/CreatorOffice";
export const URL_POST_TEST_INTEGRATION_CONNECTION = "/Integration/${IntegrationId}/TestConnection";
//#endregion

const _getContractorExportAndIntegrationsSetting = new CancellableHelper<ContractorExportIntegrationSettingResponse>(
  URL_GET_CONTRACTOR_EXPORT_INTEGRATION_SETTING,
  ContractorExportIntegrationSettingResponse
);
export const getContractorExportAndIntegrationsSetting = async (
  contractorId: string
): Promise<ContractorExportIntegrationSettingResponse> => {
  return await _getContractorExportAndIntegrationsSetting.get({
    ContractorId: contractorId,
  });
};

const _editExportBetweenOfficeSetting = new CancellableHelper<null>(
  URL_POST_EDIT_EXPORT_BETWEEN_OFFICE_SETTING,
  null,
  true
);
export const editExportBetweenOfficeSetting = async (
  contractorId: string,
  exportBetweenOffice: ExportBetweenOfficeSetting
): Promise<null> => {
  return await _editExportBetweenOfficeSetting.post({ ContractorId: contractorId }, exportBetweenOffice);
};

const _getCostDocumentCreatorOffice = new CancellableHelper<Array<SelectItem>>(
  URL_GET_COST_DOCUMENT_CREATOR_OFFICE,
  SelectItem
);
export const getCostDocumentCreatorOffice = async (): Promise<Array<SelectItem>> => {
  return await _getCostDocumentCreatorOffice.get();
};

const _addPairCostDocument = new CancellableHelper<null>(URL_POST_ADD_PAIR_COST_DOCUMENT, null, true);
export const addPairCostDocument = async (contractorId: string, body: object): Promise<null> => {
  return _addPairCostDocument.post({ ContractorId: contractorId }, body);
};

const _removePairCostDocument = new CancellableHelper<null>(URL_POST_REMOVE_PAIR_COST_DOCUMENT, null, true);
export const removePairCostDocument = async (contractorId: string, pairCostDocumentId: number): Promise<null> => {
  return _removePairCostDocument.post({
    ContractorId: contractorId,
    PairCostDocumentId: pairCostDocumentId,
  });
};

const _setContractorExportSetting = new CancellableHelper<null>(URL_POST_SET_CONTRACTOR_EXPORT_SETTING, null, true);
export const setContractorExportSetting = async (
  contractorId: string,
  body: ContractorExportSetting
): Promise<null> => {
  return _setContractorExportSetting.post({ ContractorId: contractorId }, body);
};

const _editApiIntegrationSetting = new CancellableHelper<null>(URL_POST_EDIT_API_INTEGRATION_SETTING, null, true);
export const editApiIntegrationSetting = async (contractorId: string, body: object): Promise<null> => {
  return _editApiIntegrationSetting.post({ ContractorId: contractorId }, body);
};

const _savePairCostDocumentSettings = new CancellableHelper<null>(URL_POST_SAVE_PAIR_COST_DOCUMENT_SETTING, null, true);
export const savePairCostDocumentSettings = async (contractorId: string, body: object): Promise<null> => {
  return _savePairCostDocumentSettings.post({ ContractorId: contractorId }, body);
};

const _testIntegrationConnection = new CancellableHelper<null>(URL_POST_TEST_INTEGRATION_CONNECTION, null, true);
export const testIntegrationConnection = async (integrationId: string): Promise<null> => {
  return _testIntegrationConnection.post({ IntegrationId: integrationId });
};
